import React from "react";
import { styled } from "styled-components";
const SLoading = styled.div `
  background-color: white;
  border-radius: 50%;
  border: 2px solid white;
  height: 100px;
  left: 50%;
  overflow: hidden;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 100px;

  > svg {
    position: relative;
    top: 25%;

    > path {
      animation: wave 30000ms linear infinite;
      transform: translateX(0);

      @media (prefers-reduced-motion) {
        animation: none;
      }

      &:last-child {
        animation-duration: 25000ms;
      }
    }
  }

  @keyframes wave {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(-1600px);
    }
  }
`;
export const Loading = () => (React.createElement(SLoading, null,
    React.createElement("svg", { viewBox: "0 0 1800 100", height: "100", width: "900" },
        React.createElement("path", { fill: "#28B8E6", d: "M0,0\n              C100 0 100 50 200 50\n              C300 50 300 0 400 0\n              C500 0 500 50 600 50\n              C700 50 700 0 800 0\n              C900 0 900 50 1000 50\n              C1100 50 1100 0 1200 0\n              C1300 0 1300 50 1400 50\n              C1500 50 1500 0 1600 0\n              C1700 0 1700 50 1800 50\n              V100H0Z" }),
        React.createElement("path", { fill: "#51C2EB", d: "M0,20\n              C80 20 80 70 160 70\n              C240 70 240 20 320 20\n              C400 20 400 70 480 70\n              C560 70 560 20 640 20\n              C720 20 720 70 800 70\n              C880 70 880 20 960 20\n              C1040 20 1040 70 1120 70\n              C1200 70 1200 20 1280 20\n              C1360 20 1360 70 1440 70\n              C1520 70 1520 20 1600 20\n              C1680 20 1680 70 1760 70\n              V100H0Z" }))));
export const FormatLoadingWrapper = styled.div(({ backgroundColor = "transparent", border = "1px solid black", ...props }) => ({
    "&:first-child > div": {
        zIndex: "1001",
        backgroundColor,
        border,
        ...props,
    },
}));
export default Loading;
//# sourceMappingURL=Loading.js.map